module.exports = __webpack_public_path__ + "img/provision-admin.0d43c5db.svg";